import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackText from "../Input/FeedbackText";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question4CoachingMethodology = ({
  processImprovementFeedback,
  updateFormData,
  onEnterKeyPress,
}) => {
  return (
    <>
      <FeedbackFormLayout
        title={"Experience with the coaching methodology"}
        subtitle={
          "Tell us more about if and how the coaching steps and structure help you."
        }
      >
        <FeedbackHeader
          title={
            "What suggestions do you have for improving the coaching process in the future?"
          }
        />
        <FeedbackText
          inputID={"processImprovementFeedback"}
          inputText={processImprovementFeedback}
          updateFormData={updateFormData}
          onEnterKeyPress={onEnterKeyPress}
          placeHolder={"E.g. evaluation method, support ecosystem"}
        />
      </FeedbackFormLayout>
    </>
  );
};
